import React from 'react'


const Card = ({ cardType, img, title, click, isClaimed }) => {
    return (
        <>
            {cardType === 'insideHeading' ? (
                <div
                    className={`relative rounded overflow-hidden mb-3 ${click ? 'cursor-pointer' : ''}`} onClick={click ? click : undefined}>
                    <img src={img} alt="" className="w-full h-[160px] object-cover" />

                    <div className="absolute bottom-0 left-0 right-0 bg-[#0000008a] px-2 py-2 text-white">
                        <p className="mb-0 text-center">{title}</p>
                    </div>
                </div>
            ) : (
                <div className={`relative rounded-2xl overflow-hidden mb-3 ${click ? 'cursor-pointer' : ''}`} onClick={click ? click : undefined}>
                    <img src={img} alt="" className="rounded w-full h-[190px] object-fill" />

                    {
                        isClaimed && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-xl font-bold">
                                Claimed
                            </div>
                        )
                    }
                    {title && (
                        <div className="px-2 py-2 text-black">
                            <p className="mb-0 text-left">{title}</p>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default Card